import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import {
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useEffect, useState } from 'react';
import { PRPService } from 'services/PRPService';
import { formatDate } from 'utils';
import { priceRender } from 'utils/table';
import { PRPForm } from './PRPForm';
import { PRPTable } from './PRPTable';

function PRP() {
  useDocumentTitle('Пределы расчетных показателей');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger('Пределы расчетных показателей');
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();

  useEffect(() => {
    fetchItems();
  }, [page, perPage]);

  const fetchItems = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await PRPService.getPRP(page, perPage);

      setItems(items);
      setCount(total);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await PRPService.deletePRP(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="prp" />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          { label: 'Статья', key: 'name' },
          { label: 'Ставка для работников', key: 'work_rate' },
          {
            label: 'Ставка для ИП',
            key: 'ip_rate',
            computedValue: `${priceRender(activeRecord?.ip_rate)} ₸`,
          },
          {
            label: 'База',
            key: 'base',
            computedValue: `${priceRender(activeRecord?.base)} ₸`,
          },
          {
            label: 'Макс',
            key: 'max_value',
            computedValue: `${priceRender(activeRecord?.max_value)} ₸`,
          },
          {
            label: 'Предельный доход налогооблажения',
            key: 'max_tax_income',
            computedValue: `${priceRender(activeRecord?.max_tax_income)} ₸`,
          },
          {
            label: 'Объект налогоблажение с вычетом',
            key: 'tax_deducation',
            computedValue: `${priceRender(activeRecord?.tax_deducation)} ₸`,
          },
          {
            label: 'Объект налогоблажение без  вычета',
            key: 'tax_without_deducation',
            computedValue: `${priceRender(
              activeRecord?.tax_without_deducation
            )} ₸`,
          },
          {
            label: 'Дата начала',
            key: 'begin_date',
            computedValue: formatDate(activeRecord?.begin_date),
          },
          {
            label: 'Дата окончание',
            key: 'end_date',
            computedValue: formatDate(activeRecord?.end_date),
          },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить эту запись ?"
        pageId="prp"
      />

      <PRPTable
        items={items}
        loading={loading}
        totalRows={totalRows}
        current={page}
        pageSize={perPage}
        onRowClick={openDrawer}
        onChange={setPagination}
      />

      <PRPForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { PRP };
